import React from "react";
import Navbar from "../../components/navbar/Navbar";
import Sidebar from "../../components/sidebar/Sidebar";
import IPDRegister from "./ipdRegister";

const IpdRegisterContainer = () => {
    return (
        <div className="list">
            <Sidebar />
            <div className="listContainer">
                <Navbar />
                <IPDRegister />

            </div>
        </div>
    )
}

export default IpdRegisterContainer;
